const range = require('lodash/range');
const plugin = require('tailwindcss/plugin');

const innerBorderRadiusUtils = plugin(function ({addUtilities}) {
  addUtilities([
    ...range(1, 20).map(num => {
      return {
        [`.inner-line-rounded-${num}px`]: {
          '&::after': {'border-radius': `${num}px`},
        },
      };
    }),
    {
      [`.inner-line-rounded-full`]: {
        '&::after': {'border-radius': '9999px'},
      },
    },
  ]);
});

module.exports = innerBorderRadiusUtils;
